var PageRating = ( function() {
	var C = function(){ return constructor.apply(this,arguments); };
	var p = C.prototype;

	p.$rating = null;

	function constructor( rating ) {
		var self = this;
		this.$rating = jQuery( rating );
		this.setup();
	};

	// Setup popup
	p.setup = function() {
		this.$rating.find( '.content-page-rating__rating-link' )
			.on('click', this.handleRating.bind( this ) );
		this.$rating.find( '.content-page-rating__reset-button' )
			.on('click', this.resetRating.bind( this ) );
	};

	// Handle reset requests
	p.resetRating = function( event ) {
		var $button = jQuery( event.currentTarget );
		var self = this;
		jQuery.post( {
			url: iPortalCore.ajaxURL,
			data: {
				action: 'iportal_page_rating_reset',
				_ajax_nonce: $button.data( 'nonce' ),
				page_id: this.$rating.data( 'page-id' )
			},
			success: function( response ) {
				var $message = jQuery(
					'<div class="badge badge-'
						+ ( response.success ? 'success' : 'danger' )
						+ '" role="alert">'
						+ response.data.message + '</div>' );
				self.$rating.html( $message );
			},
			error: function( response ) {
				var $error = jQuery( '<div class="badge badge-danger" role="alert">' + response.data.message + '</div>' );
				self.$rating.html( $error );
			}
		} );
	};

	// Handle ratings
	p.handleRating = function( event ) {
		event.preventDefault();
		var self = this;
		var $link = jQuery( event.currentTarget );
		var rating = $link.data( 'stars' );
		jQuery.post( {
			url: iPortalCore.ajaxURL,
			data: {
				action: 'iportal_page_rating',
				page_id: this.$rating.data( 'page-id' ),
				rating: rating
			},
			success: function( response ) {
				var $message = jQuery(
					'<div class="badge badge-'
						+ ( response.success ? 'success' : 'danger' )
						+ '" role="alert">'
						+ response.data.message + '</div>' );
				self.$rating.html( $message );
			},
			error: function( response ) {
				var $error = jQuery( '<div class="badge badge-danger" role="alert">' + response.data.message + '</div>' );
				self.$rating.html( $error );
			}
		} );
	};

	return C;
} )();

export default PageRating;
